import ArrowSelectionIcon from "components/Elements/Icons/ArrowSelect"
import React from "react"
import { twMerge } from "tailwind-merge"
import { useClickAway } from "react-use"
import { useTranslation } from "react-i18next"
import { shallowEqual } from "react-redux"

import { bikeFleetStatusList, getLabelFromStatusNumber } from "features/bikeFleet/utils"
import { useAppSelector } from "store/hooks"
import { bikeFleetStatusListProps } from "features/bikeFleet/types/bikeFleetType"
import {
	noStatusSelectedSelector,
	numberOfBikeSelectedStringifySelector,
} from "features/bikeFleet/slice/bikeFleetSelector"
import { BikeFleetStatusModal } from "../BikeFleetStatusModal"

export const SelectStatusBikeFleet : React.FC = () => {
	const [open, setOpen] = React.useState(false)
	const [selectedStatus, setSelectedStatus] = React.useState<bikeFleetStatusListProps | false>(
		false
	)
	const ref = React.useRef<HTMLDivElement>(null)
	const { t } = useTranslation()
	const currentStatus = useAppSelector(
		(state) => state.bikeFleet.currentBikeFleetStatusSelected,
		shallowEqual
	)
	const numberOfBikeSelectedStringify = useAppSelector(
		numberOfBikeSelectedStringifySelector,
		shallowEqual
	)
	const isNoStatusSelected = useAppSelector(noStatusSelectedSelector, shallowEqual)

	useClickAway(ref, () => {
		setOpen(false)
	})

	const isStatusDisabled = (status: number) => {
		return (currentStatus === String(status))
	}

	const onSelectStatus = (status: number) => {
		setOpen(false)
		setSelectedStatus(status)
	}

	return (
		<>
			<div
				ref={ref}
				className={twMerge(
					"relative h-[40px] z-20",
					isNoStatusSelected && "opacity-30 pointer-events-none cursor-not-allowed"
				)}
			>
				<div
					data-cy="open-status"
					onClick={() => setOpen((prev) => !prev)}
					onKeyDown={() => setOpen((prev) => !prev)}
					className={twMerge(
						"border-[var(--primaryColor)] border-t w-full h-full flex items-center p-2  justify-between cursor-pointer",
						open ? "border-t border-l border-r rounded-t" : "border rounded"
					)}
					role="button"
					tabIndex={0}
				>
					<span>
						{t("bikeFleet.actions.changeStatus", {
							ns: "bike",
							number: numberOfBikeSelectedStringify,
						})}
					</span>
					<ArrowSelectionIcon width={20} height={20} />
				</div>
				{open && (
					<div
						aria-disabled
						className=" bg-white z-2 rounded-b-md border-b border-l border-r border-[var(--primaryColor)] w-full"
					>
						{bikeFleetStatusList.map((status: number, key: number) => {
							const disabledStatus = isStatusDisabled(status)
							return (
								<div
									data-cy={`status-${key}-choice`}
									key={`status-${key}`}
									onClick={() => onSelectStatus(status)}
									onKeyDown={() => onSelectStatus(status)}
									className={twMerge(
										"p-2 box-border",
										"hover:bg-slate-200",
										disabledStatus
											? "opacity-30 pointer-events-none cursor-not-allowed"
											: "opacity-1 cursor-pointer pointer-events-auto"
									)}
									role="button"
									tabIndex={key}
								>
									{getLabelFromStatusNumber(status)}
								</div>
							)
						})}
					</div>
				)}
			</div>
			{selectedStatus && (
				<BikeFleetStatusModal
					selectedStatus={selectedStatus}
					onClose={() => setSelectedStatus(false)}
				/>
			)}
		</>
	)
}
